const React = require('react');
const isNode = (typeof process !== 'undefined');

class Search extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.searchInput.focus();
    }

    render() {
        const { searchPage, toggleSearch } = this.props;
        return (
        <section className="search">
            <a onClick={toggleSearch}>
                <svg className="search__close" version="1.1"  x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000">
                    <g><path d="M500,623.8L159.9,963.9c-34.6,34.6-90.1,34.7-124.3,0.5c-34.4-34.4-34-89.8,0.5-124.3L376.2,500L36.1,159.9C1.5,125.3,1.4,69.8,35.6,35.6c34.4-34.4,89.8-34,124.3,0.5L500,376.2L840.1,36.1c34.6-34.6,90.1-34.7,124.3-0.5c34.4,34.4,34,89.8-0.5,124.3L623.8,500l340.1,340.1c34.6,34.6,34.7,90.1,0.5,124.3c-34.4,34.4-89.8,34-124.3-0.5L500,623.8z"/></g>
                </svg>
            </a>
            <div className="search__container">
                <form action={searchPage} method="get">
                    <label className="search__title" htmlFor="search__input">Søk</label>
                    <input className="search__input" type="text" name="q" ref={(searchInput) => this.searchInput = searchInput}/>
                </form>
            </div>
        </section>
        )
    }
}

module.exports = Search;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Search/index.jsx